/* Eagle Leather: contact form validation state (2026-10-01).
   Native browser validation still blocks the submit; this only adds the accessible state AFTER a failed
   validation: aria-invalid="true" on the field plus a visible error message tied with aria-describedby.
   The state clears as soon as the field becomes valid. The form still posts to Shopify's contact endpoint.
   2026-10-02: focus moves to the first invalid field after a failed submit; a field can supply its own
   "required" message through data-el-missing (used by the contact message textarea). */
(function () {
  'use strict';
  var silent = false;
  function errId(field) {
    return (field.id || field.name.replace(/[^a-z0-9_-]/gi, '-')) + '-el-error';
  }
  function container(field) {
    return field.closest('.form-field') || field.parentElement;
  }
  function addDescribedBy(field, id) {
    var ids = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    if (ids.indexOf(id) === -1) ids.push(id);
    field.setAttribute('aria-describedby', ids.join(' '));
  }
  function removeDescribedBy(field, id) {
    var ids = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (x) { return x && x !== id; });
    if (ids.length) field.setAttribute('aria-describedby', ids.join(' '));
    else field.removeAttribute('aria-describedby');
  }
  function group(field) {
    if (field.type === 'radio' && field.form && field.name) {
      return Array.prototype.slice.call(field.form.querySelectorAll('input[type="radio"]')).filter(function (r) { return r.name === field.name; });
    }
    return [field];
  }
  function markInvalid(field) {
    var id = errId(group(field)[0]);
    var box = container(field);
    var msg = document.getElementById(id);
    if (!msg) {
      msg = document.createElement('span');
      msg.id = id;
      msg.className = 'form-message form-message--small form-message--error el-form-error';
      box.appendChild(msg);
    }
    var text = field.validationMessage || 'Please check this field.';
    if (field.validity && field.validity.valueMissing && field.getAttribute('data-el-missing')) text = field.getAttribute('data-el-missing');
    if (field.validity && field.validity.patternMismatch && field.title) text = field.title;
    msg.textContent = text;
    group(field).forEach(function (f) {
      f.setAttribute('aria-invalid', 'true');
      addDescribedBy(f, id);
    });
  }
  function clearInvalid(field) {
    var members = group(field);
    var id = errId(members[0]);
    members.forEach(function (f) {
      if (f.getAttribute('aria-invalid') === 'true') f.removeAttribute('aria-invalid');
      removeDescribedBy(f, id);
    });
    var msg = document.getElementById(id);
    if (msg) msg.remove();
  }
  function onUpdate(e) {
    var field = e.target;
    if (!field || !field.willValidate) return;
    if (field.getAttribute('aria-invalid') !== 'true') return;
    silent = true;
    var ok = field.checkValidity(); // fires "invalid" when bad; silent keeps focus where the user is
    silent = false;
    if (ok) clearInvalid(field);
    else markInvalid(field);
  }
  function init(form) {
    if (form.dataset.elValidate) return;
    form.dataset.elValidate = '1';
    var focusPending = false;
    form.addEventListener('invalid', function (e) {
      markInvalid(e.target);
      // One submit attempt fires "invalid" on every bad field in DOM order: focus the first one only.
      if (!silent && !focusPending) {
        focusPending = true;
        try { e.target.focus({ preventScroll: false }); } catch (err) { e.target.focus(); }
        setTimeout(function () { focusPending = false; }, 0);
      }
    }, true);
    form.addEventListener('input', onUpdate);
    form.addEventListener('change', onUpdate);
  }
  function run() {
    document.querySelectorAll('form[id^="ContactForm-"]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
